module.exports = __webpack_public_path__ + "static/img/service_center_mo.573e5d7c.jpg";